import React, { Component, forwardRef, useState, useImperativeHandle } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Map } from 'immutable';
import pluralize from 'pluralize';
import currencyFormat from 'utils/currency/numberToPrice';
import { deferExecutor } from 'app/DeferredOnLocation';
import Confirm from 'app/components/Confirm';
import Button, { SolidButton } from 'components/Button';
import Link from 'components/Link';
import ToggleList from 'app/components/LeftPanel/Section';
import LeftPart from 'app/components/LeftPanel/Wrapper';
import AddToGroup from 'app/components/AddToGroup';
import AddToFolder from 'app/components/AddToFolder';
import Prompt from 'app/components/Prompt';
import { SearchFilterViewerPopupNew } from 'app/components/SearchFilter';
import CustomFilterModal from './CustomFilterModal';
import DropdownMenu from 'components/base/DropdownMenu';
import ContractManagerPopup from 'app/components/ContractManager';
import PostcardPreviewPopup from 'app/Campaigns/Postcard/preview';
import AppendJobEditor from 'app/Contacts/AppendJobEditor';
import ListAutomatorPopover from 'app/components/ListAutomatorPopover';
import ExportPropertyConfirmation from 'app/components/ExportPropertyConfirmation';
import mapFieldColumns, { PropertyAddressCellRenderer } from 'utils/grid';
import { isLaAvailable, isPropStream } from 'utils/brand';
import GridLayoutEditor from 'app/components/GridLayoutEditor';
import LaunchControlConfirmation from 'app/components/LaunchControlConfirmation';
import MailingLabelsPopup from 'app/components/MailingLabels';
import { MAIN_CONTEXT } from 'reducers';
import { selectPropertyGridLayout, selectListManagementEnabled, selectLayouts, selectFullAccessPermission } from 'data/user';
import { selectLoading as selectCampaignLoading, createSmsCampaign, selectSmsEnabled, selectSmsRegistered } from 'data/campaigns';
import { selectLoading as selectContactLoading } from 'data/contacts';
import { createDialerCampaign, getBatchDialerIntegration, openLeadAutomatorUpgrade, setBatchDialerSource, getMarketingProfile } from "../../../data/user/actions";
import { selectUsageSection, selectPlanDetails, isLegacyAccountPlan } from '../../../data/user/selectors';
import { loadCampaign, loadCampaigns, createDirectMailCampaign } from 'data/campaigns/actions';
import CreateDirectMailHandler from 'app/Campaigns/Dashboard/DirectMail/CreateDirectMailHandler';
import CampaignActivitySettingsModal, {
  CAMPAIGN_ACTIVITY_SETTINGS_CONTEXT,
  CAMPAIGN_ACTIVITY_TYPE,
} from 'app/Campaigns/CampaignActivitySettingsModal';
import LeaveMessagePopup from '../../AccountNew/modals/LeaveMessage';
import PurchaseSavesAndExportsPopup from "../../AccountNew/modals/PurchaseSavesAndExports";
import {
  selectGroupContext,
  selectGroups,
  selectFavorites,
  selectLists,
  selectMonitoredLists,
  selectAlerts,
  selectLoading,
  selectExportInProgress,
  selectFilters,
  selectFolders,
  loadGroupContext,
  updateGroupContext,
  exportGroupProperties,
  deletePropertyGroup,
  saveGroupProperties,
  PropertyGroupTypes,
  GroupListingTypes,
  GroupTypeNames,
  searchGroupProperties,
  getSavedPropertyDetail,
  selectSelection,
  setPropertySelection,
  clearPropertySelection,
  deleteGroupProperties,
  searchPropertyContacts,
  getGroupSearch,
  saveGroupSearch,
  selectSearches,
  savePropertyGroupFilter,
  deletePropertyGroupFilter,
  selectGroupCounts,
  getGroupPropertyCounts,
  savePropertyFolder,
  deletePropertyFolder,
} from 'data/property';
import classNames from 'classnames';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

import Tile from './Tile';
import CarouselTile from './Tile/CarouselTile';
import IndexCellRenderer from './indexCellRenderer';
import IndexHeaderRenderer from './indexHeaderRenderer';
import DetailCellRenderer from './detailCellRenderer';
import LoadingCellRenderer from './loadingCellRenderer';
import GridDateComponent from './gridDateComponent';
import PropertyImport from './Import';
import Options from './Options';
import getAutomateListVisibility from './getAutomateListVisibility';
import MyPropertiesControls from '../MyPropertiesControls';
import PropertyGroupMap from './Map';
import css from './style.scss';
import PushtoBatchDialer from '../../../components/PushtoBatchDialer';
import { withRouter } from 'react-router-dom';
import { propertyGroupPath } from '../../routes';
import { getMatchingPCScoreValues, getMatchingFFScoreValues } from '../../Search/Header/searchFilterNew/shared/ConstantsNew';
import { isNDAState } from '../../../utils/ndaStates';
import BatchDialer from '../../AccountNew/modals/BatchDialer';
import BatchDialerPage from '../../components/BatchdialerModal';
import { selectProfile } from 'data/user';
import BatchDialerModal from '../../components/BatchdialerModal';
import { selectBatchDialerList, selectUserId } from "data/user/selectors";
import BatchDialerAlert from '../../components/BatchdialerAlert';
import InfoAlert from '../../components/InfoAlert';
import ContactCellRenderer from '../../components/SearchTable/ContactCellRenderer';
import SkipTraceModal from 'app/components/SkipTraceModal';
import { selectAppendGroups } from '../../../data/contacts';
import { getAppendJobEstimate } from '../../../data/contacts/actions';
import ClickToDial from '../../../components/ClickToDial';
import ActivateSubscriptionPopup from '../../AccountNew/modals/ActivateSubscription';
import FullAccessRequiredModal from "components/ClickToDial/FullAccessRequiredModal/FullAccessRequiredModal";
import { checkDialerCampaignAccess } from '../../Campaigns/dialerCampaignAccess';

import LeadAutomatorUpgrade from '../../../components/DialerCampaign/LeadAutomatorUpgrade/LeadAutomatorUpgrade';
import { openClickToDial } from "../../../data/user/actions";
import dropdownCss from 'components/base/DropdownMenu/style.scss';
import { authenticate } from '../../../data/user/actions';
import AddToMarketingListModal from '../../components/AddToMarketingListModal';
import SimpleModal from '../../../components/base/SimpleModal';
import RemovePropertyConfirmModal from './RemovePropertyConfirmModal';
import RenameListModal from '../../components/RenameListModal';
import ActionDropdownMenu from '../../../components/base/ActionDropdownMenu';
import SVG from 'components/base/SVG';

// Keeps the group/expand column's header blank in the grid while still labeling it "Id" in the Columns Tool Panel.
const BlankHeader = () => null;

// Folder icon (16x12, Teal/500) for "Pin Column"; positions itself absolutely to fit AG Grid's 8px-wide icon slot.
const PIN_COLUMN_MENU_ICON = `<span style="position:absolute;top:50%;left:2px;width:16px;height:12px;margin-top:-6px;display:block;background-color:#128292;-webkit-mask-repeat:no-repeat;-webkit-mask-position:center;-webkit-mask-size:16px 12px;-webkit-mask-image:url(&quot;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='2 4 16 12' fill='%23000'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4 4C2.895 4 2 4.895 2 6V14C2 15.105 2.895 16 4 16H16C17.105 16 18 15.105 18 14V8C18 6.895 17.105 6 16 6H11L9 4H4ZM11 9C11 8.448 10.552 8 10 8C9.448 8 9 8.448 9 9V10H8C7.448 10 7 10.448 7 11C7 11.552 7.448 12 8 12H9V13C9 13.552 9.448 14 10 14C10.552 14 11 13.552 11 13V12H12C12.552 12 13 11.552 13 11C13 10.448 12.552 10 12 10H11V9Z'/%3E%3C/svg%3E&quot;);mask-repeat:no-repeat;mask-position:center;mask-size:16px 12px;mask-image:url(&quot;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='2 4 16 12' fill='%23000'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4 4C2.895 4 2 4.895 2 6V14C2 15.105 2.895 16 4 16H16C17.105 16 18 15.105 18 14V8C18 6.895 17.105 6 16 6H11L9 4H4ZM11 9C11 8.448 10.552 8 10 8C9.448 8 9 8.448 9 9V10H8C7.448 10 7 10.448 7 11C7 11.552 7.448 12 8 12H9V13C9 13.552 9.448 14 10 14C10.552 14 11 13.552 11 13V12H12C12.552 12 13 11.552 13 11C13 10.448 12.552 10 12 10H11V9Z'/%3E%3C/svg%3E&quot;);"></span>`;

// Dialer "New!" badge Visible for 90 days from PROD release date

const isDialerFeatureNew = () => {
  // PROD release date for Dialer feature
  const FEATURE_START_DATE = new Date('2026-01-09T23:59:59');
  const EXPIRATION_DAYS = 90;

  const expirationDate = new Date(FEATURE_START_DATE);
  expirationDate.setDate(expirationDate.getDate() + EXPIRATION_DAYS);

  return new Date() < expirationDate;
};

const deleteWarning = 'Notice: Deleting properties does not provide access to more Saves. Access the Settings section to increase the Save limit.';

// Just Sold / Low Equity / Neg Equity have no equivalent in the Search page's
// Lead List catalog, so they're excluded everywhere My Properties surfaces
// filter tiles (the top CarouselTile bar and the Lead List edit/view pickers)
// to keep the two pages' filter sets consistent.
const NON_LEAD_LIST_TYPES = ['J', 'Q', 'Y'];

const groupTypeName = item => GroupTypeNames[typeof item === 'string' ? item : item.getIn(['info', 'type'], item.get('type'))];

const localText = {
  inRange: 'In Range',
};

// TODO: Importing these from app/routes cause the component to not hot-reload, probably due to co-dependency. Move functions to common location.
// const getPath = (root, path) => `${root}${path || path === 0 ? `/${path}` : ''}`;
// export const propertyGroupPath = path => getPath('/property/group', path);

// Function to extract only the date part from a date time string
function extractDate(dateString) {
  if (!dateString) return null; // Return null if dateString is not provided
  const dateOnly = dateString.split(' ')[0]; // Extract the date portion
  return dateOnly;
}

// Function to get filters from filter model and apply formatting if needed
const getFilters = (filterModel = {}, cols = []) => {
  // Iterate through each field in the filterModel
  return Object.keys(filterModel).reduce((ar, field) => {
    const selectedColFilter = cols.find(itm => itm.colId === field)?.userProvidedColDef;
    // Check if fieldType is "DOUBLE"
    if (selectedColFilter?.fieldType === 'DOUBLE') {
      const filterValues = getMatchingPCScoreValues(filterModel[field].filter)
      if (filterValues && filterValues.length) {
        filterValues.forEach(itm => ar.push({
          field,
          ...filterModel[field], filterType: selectedColFilter.fieldType, filter: itm
        }));
      } else {
        ar.push({ field, ...filterModel[field], filterType: selectedColFilter.fieldType, filter: null });
      }
    } else if (selectedColFilter?.fieldType === 'CHAR') {
      const filterValues = getMatchingFFScoreValues(filterModel[field].filter)
      if (filterValues && filterValues.length) {
        filterValues.forEach(itm => ar.push({
          field,
          ...filterModel[field], filterType: selectedColFilter.fieldType, filter: itm
        }));
      } else {
        ar.push({ field, ...filterModel[field], filterType: selectedColFilter.fieldType, filter: null });
      }
    }
    else if (filterModel[field].filterType === "date") { // Check if filterType is "date"
      // If filterType is "date", apply extractDate method to format the value
      if (filterModel[field].condition1) {
        ar.push({
          field, ...filterModel[field],
          condition1: {
            ...filterModel[field].condition1,
            dateFrom: extractDate(filterModel[field].condition1.dateFrom),
            dateTo: extractDate(filterModel[field].condition1.dateTo)
          },
          condition2: {
            ...filterModel[field].condition2,
            dateFrom: extractDate(filterModel[field].condition2.dateFrom),
            dateTo: extractDate(filterModel[field].condition2.dateTo)
          },
        }
        );
      } else {
        ar.push({ field, ...filterModel[field], dateFrom: extractDate(filterModel[field].dateFrom), dateTo: extractDate(filterModel[field].dateTo) });
      }
    } else if (field === 'ownerOccupied') {
      const filter = filterModel[field]?.filter;

      console.log('ownerOccupied', filter);

      if (filter != null) {
        ar.push({
          field,
          filter: filter.toLowerCase() === 'yes'
        });
      }
    } else {
      // If filterType is not "date", directly include the field and value
      ar.push({ field, ...filterModel[field] });
    }
    return ar;
  }, []);
};

const getSingleRecordSelection = id => ({ allSelected: false, remainingSelected: false, selected: 1, selectedIds: [id], unselectedIds: [] });
const getListingTypeFilter = listingType => ({ field: 'types', filter: listingType, filterType: 'text', type: 'contains' });

const YesNoFloatingFilter = forwardRef((props, ref) => {
  const [value, setValue] = useState('');

  useImperativeHandle(ref, () => ({
    onParentModelChanged(model) {
      setValue(model ? model.filter || '' : '');
    },
  }));

  const onChange = (e) => {
    const val = e.target.value;
    setValue(val);
    props.parentFilterInstance((instance) => {
      if (instance?.onFloatingFilterChanged) {
        instance.onFloatingFilterChanged('equals', val || null);
        return;
      }

      instance.setModel(val ? { filterType: 'text', type: 'equals', filter: val } : null);
      props.api?.onFilterChanged();
    });
  };

  return (
    <select
      value={value}
      onChange={onChange}
      style={{
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        height: '16.86px',
        appearance: 'auto',
        borderColor: 'var(--ag-input-border-color, #95a5a6)',
        borderWidth: '1px',
        borderStyle: 'solid'
      }}
    >
      <option value="">{props?.displayNoSelectionAsAll === true ? "All" : null}</option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
    </select>
  );
});

let i = 0;
class PropertyGroup extends Component {
  // Delay for grid DOM to be fully rendered before accessing scroll container
  static GRID_DOM_READY_DELAY_MS = 100;
  // Quiet period with no further detail-content resize before scrollExpandedRowIntoView
  // runs, so it reacts to the settled height rather than an intermediate one.
  static SCROLL_INTO_VIEW_STABLE_DELAY_MS = 150;
  // Spacing/count for scrollExpandedRowIntoView's post-scroll retries, which wait out
  // AG Grid's own ~100ms detailRowAutoHeight debounce (see AutoHeightService) before
  // this container's scrollHeight has grown enough to permit the full scroll distance.
  static SCROLL_INTO_VIEW_RETRY_DELAY_MS = 120;
  static SCROLL_INTO_VIEW_MAX_RETRIES = 5;

  constructor(props) {
    super(props);

    this.handleOpenContractManager = this.handleOpenContractManager.bind(this);
    this.handleAddGroup = this.handleAddGroup.bind(this);
    this.handleAddToFolder = this.handleAddToFolder.bind(this);
    this.handleAddFolder = this.handleAddFolder.bind(this);
    this.handleDeleteFolder = this.handleDeleteFolder.bind(this);
    this.handleEditFolder = this.handleEditFolder.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleRemoveDuplicates = this.handleRemoveDuplicates.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleDeleteDrop = this.handleDeleteDrop.bind(this);
    this.handleGroupDrop = this.handleGroupDrop.bind(this);
    this.handleDeleteGroup = this.handleDeleteGroup.bind(this);
    this.handleRename = this.handleRename.bind(this);
    this.handleImport = this.handleImport.bind(this);
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.handleGridReady = this.handleGridReady.bind(this);
    this.getContextMenuItems = this.getContextMenuItems.bind(this);
    this.handleGridDetail = this.handleGridDetail.bind(this);
    this.handleGridModelUpdated = this.handleGridModelUpdated.bind(this);
    this.handleGridRowGroupOpened = this.handleGridRowGroupOpened.bind(this);
    this.collapseExpandedDetail = this.collapseExpandedDetail.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleMarketingCellClicked = this.handleMarketingCellClicked.bind(this);
    this.handleViewFilter = this.handleViewFilter.bind(this);
    this.handleEditFilter = this.handleEditFilter.bind(this);
    this.handleEditGroupFilter = this.handleEditGroupFilter.bind(this);
    this.handleNewCampaign = this.handleNewCampaign.bind(this);
    this.openCampaignActivitySettingsModal = this.openCampaignActivitySettingsModal.bind(this);
    this.handleModalSave = this.handleModalSave.bind(this);
    this.handleTotalClick = this.handleTotalClick.bind(this);
    this.handleFilterClick = this.handleFilterClick.bind(this);
    this.search = this.search.bind(this);
    this.setActiveDetail = this.setActiveDetail.bind(this);
    this.handleGridLayoutApply = this.handleGridLayoutApply.bind(this);
    this.handleOpenMap = this.handleOpenMap.bind(this);
    this.handleGenerateMailingLabels = this.handleGenerateMailingLabels.bind(this);
    this.handleDetailPosition = this.handleDetailPosition.bind(this);
    this.positionDetailContent = this.positionDetailContent.bind(this);
    this.updateDetailPosition = this.updateDetailPosition.bind(this);
    this.scrollExpandedRowIntoView = this.scrollExpandedRowIntoView.bind(this);
    this.scheduleScrollIntoView = this.scheduleScrollIntoView.bind(this);
    this.handleConfirmModalConfirm = this.handleConfirmModalConfirm.bind(this);
    this.handleConfirmModalCancel = this.handleConfirmModalCancel.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.showConfirmModal = this.showConfirmModal.bind(this);
    this.handleRemovePropertyConfirm = this.handleRemovePropertyConfirm.bind(this);
    this.handleRemovePropertyCancel = this.handleRemovePropertyCancel.bind(this);

    const { getSavedPropertyDetail, openPostcardPreview, lmEnabled, layout } = props;

    this.processingRows = false;
    this.activeDetail = null;
    this.lastSelectedId = null;
    this.gridRowCount = 0;


    // Instance variables for scroll listener cleanup
    this.scrollHandler = null;
    this.scrollContainer = null;
    this._detailPositionScheduled = false;
    this._scrollIntoViewTimer = null;
    this._scrollRetryTimer = null;

    const lmColumnSettings = {
      cellClass: ({ value }) => (value ? css.marketingCell : null),
      onCellClicked: this.handleMarketingCellClicked,
      hidden: !lmEnabled,
    };

    // For Whitelabel accounts, we remove the 'Dialer Campaigns' functionality
    this.columns = layout.toJS().sections.reduce((ar, s) =>
      ar.concat(s.fields.filter(field => field.path !== "dialerContactedCount" || isPropStream()).map(({ id, name, path, width, pin, hidden, type }) =>
        ({ group: s.name, name, width, pin, hidden, path, type, lmRequired: s.code === 'MARKETING' && id !== 584 }))), []);

    this.columnPresets = {
      campaignQuantity: lmColumnSettings,
      voicemailCampaignQuantity: lmColumnSettings,
      postcardCampaignQuantity: lmColumnSettings,
      emailCampaignQuantity: lmColumnSettings,
      contactAppendQuantity: lmColumnSettings,
      dialerContactedCount: lmColumnSettings,
      listQuantity: {
        ...lmColumnSettings,
        hidden: false,
        cellClass: ({ value }) => (value ? css.marketingCell : null),
      },
      litigator: {
        filter: 'agTextColumnFilter',
        floatingFilterComponent: YesNoFloatingFilter,
        floatingFilterComponentParams: { suppressFilterButton: true },
      },
    };


    this.gridContext = {
      onDragStart: this.handleDragStart,
      onDragEnd: this.handleDragEnd,
      onSelect: this.handleSelect,
      setActiveDetail: this.setActiveDetail,
      getSavedPropertyDetail,
      openPostcardPreview,
      groupId: 0,
      detailExpandField: null,
      search: this.search,
    };

    const { layoutId, columnDefs } = this.getColumnInfo(props);

    this.gridProps = {
      onGridReady: this.handleGridReady,
      onModelUpdated: this.handleGridModelUpdated,
      onRowGroupOpened: this.handleGridRowGroupOpened,
      rowModelType: 'serverSide',
      getRowId: params => params.data.id,
      infiniteInitialRowCount: 1500,
      cacheBlockSize: 500,
      blockLoadDebounceMillis: 150,
      maxConcurrentDatasourceRequests: 2,
      suppressCellFocus: true,
      enableCellTextSelection: true,
      // Row / header / floating-filter box heights. AG Grid writes these as
      // inline styles per row, so they must be set here (not via CSS) — see
      // ag-grid-modern-theme() in mixins.scss for the visual styling.
      rowHeight: 48,
      headerHeight: 44,
      floatingFiltersHeight: 46,
      defaultColDef: {
        resizable: true, sortable: true, menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        minWidth: 65,
      },
      columnDefs,
      detailRowAutoHeight: true,
      detailCellRendererParams: {
        detailGridOptions: {
          columnDefs: [
            { headerName: 'ID', field: 'id', width: 50 },
            { headerName: 'Test', field: 'test', width: 55 },
          ],
        },
        getDetailRowData: this.handleGridDetail,
        components: {
          detailCellRenderer: DetailCellRenderer,
        },
      },
      suppressServerSideInfiniteScroll: false,
      masterDetail: true,
      isRowMaster: () => true, // d.listQuantity > 1 || (lmEnabled && !!d.campaignQuantity),
      // keepDetailRows: true, Only disabling because the tab auto-selection won't work the second time it's opened, if opening via clicking the marketing columns.
      keepDetailRowsCount: 1000,
      detailCellRenderer: 'detailCellRenderer',
      loadingCellRenderer: LoadingCellRenderer,
      components: {
        indexCellRenderer: IndexCellRenderer,
        indexHeaderRenderer: IndexHeaderRenderer,
        blankHeader: BlankHeader,
        propertyAddressCellRenderer: PropertyAddressCellRenderer,
        detailCellRenderer: DetailCellRenderer,
        gridDateComponent: GridDateComponent,
        yesNoFloatingFilter: YesNoFloatingFilter,
      },
      icons: {
        menuPin: PIN_COLUMN_MENU_ICON,
      },
      context: this.gridContext,
      dateComponent: 'gridDateComponent',
      getContextMenuItems: this.getContextMenuItems,
      getRowClass: (params) => {
        const resultIndex = params.node.detail
          ? params.node.parent && params.node.parent.data && params.node.parent.data.resultIndex
          : params.data && params.data.resultIndex;
        if (resultIndex == null) return undefined;
        return resultIndex % 2 === 1 ? 'row-stripe-even' : 'row-stripe-odd';
      },
    };

    // eslint-disable-next-line no-param-reassign,no-return-assign
    // this.gridProps.columnDefs.forEach(c => c.headerTooltip = c.headerName);

    this.state = {
      loadId: null,
      layoutId,
      search: false,
      dragGroup: null,
      dragData: null,
      selectedTotal: '',
      selectedFilter: null,
      columnApi: null,
      listManagementUpgradeVisible: false,
      topRecords: [],
      isDropActive: false,
      isBatchDialerModalOpen: false,
      showActivitySettingsModal: false,
      pendingActivityType: null,
      pendingContactIds: [],
      removePropertyModal: null,
      showConfirmModal: false,
      confirmModalConfig: {
        title: '',
        description: '',
        onConfirm: null,
        warning: '',
        itemType: '',
        quantity: 0
      },
      showRenameModal: false,
      renameValue: '',
      renameConfig: {
        title: '',
        description: '',
        initialValue: '',
        placeholder: '',
        checkOptions: null,
        onSubmit: null
      }
    };
  }

  componentDidMount() {
    const { userId, getBatchDialerIntegration, profile } = this.props;

    const userType = profile?.get?.("type");

    i = 0;
    this.loadGroup(this.props);
    //user type fULL or team full can access batch dialer integration, so we need to check and load the integration when component mounts
    if (userId && (userType === "FULL" || userType === "TEAM_FULL")) {
      getBatchDialerIntegration(userId);
    }

    this._detailObserver = null;
    this._detailResizeObserver = null;
    try {
      // The ResizeObserver instance is created unconditionally (unlike the MutationObserver
      // below): nothing needs to `.observe()`-able yet at construction time, only when
      // updateDetailPosition() later targets it at the real rendered detail element. At
      // this point in componentDidMount, no row is expanded yet, so '.ag-full-width-container'
      // doesn't exist in the DOM — gating construction on it (as the MutationObserver setup
      // below must, since IT needs a real node to observe right away) left this observer
      // permanently null, so nothing ever reacted to the detail panel's content settling to
      // its final height after loading in asynchronously.
      if (typeof ResizeObserver !== 'undefined') {
        this._detailResizeObserver = new ResizeObserver(this.positionDetailContent);
      }

      // Scoped to this component's own grid wrapper (via ref), not the whole document —
      // the app can keep another instance of this page mounted off-screen (e.g. a cached
      // background tab), which also renders '.property-grid'/'.ag-full-width-container'
      // elements. A global document.querySelector here can silently bind to THAT instance's
      // (invisible, zero-size) elements instead of this one's, making every scroll/position
      // adjustment below a no-op on screen.
      const targetNodes = this.gridWrapperEl ? [...this.gridWrapperEl.getElementsByClassName('ag-full-width-container')] : [];
      if (targetNodes.length) {
        const config = { childList: true };
        this._detailObserver = new MutationObserver(this.positionDetailContent);
        // Watch every full-width container, not a fixed index — which one actually
        // receives the live detail content isn't stable (see updateDetailPosition).
        targetNodes.forEach((node) => this._detailObserver.observe(node, config));
      }
    } catch (e) {
    }
  }

  componentDidUpdate(prevProps) {
    const { userId, getBatchDialerIntegration, profile, match } = this.props;

    const userType = profile?.get?.("type");

    //user type fULL or team full can access batch dialer integration, so we need to check and load the integration when component mounts
    if (userId && userId !== prevProps.userId && (userType === "FULL" || userType === "TEAM_FULL")) {
      getBatchDialerIntegration(userId);
    }
    const prevGroupId = prevProps.match?.params?.groupId;
    const currGroupId = match?.params?.groupId;
    if (currGroupId !== prevGroupId) {
      this.loadGroup(this.props);
    }
  }

  componentWillMount() {
    i = 0;

    this.loadGroup(this.props);
  }

  openBatchDialerModal = () => {
    const search = this.getGridSearch ? this.getGridSearch() : null;
    const { alert } = this.props;

    if (!search || !search.selected) {
      if (typeof alert === 'function') {
        alert('Please select the record(s) you would like to add.');
      } else {
        window.alert('Please select the record(s) you would like to add.');
      }
      return;
    }
    this.props.setBatchDialerSource("PROPERTY");
    this.setState({ isBatchDialerModalOpen: true, gridSearch: search });

  };


  closeBatchDialerModal = () => {
    this.setState({ isBatchDialerModalOpen: false });
  };


  handleConfirmModalConfirm() {
    const { confirmModalConfig } = this.state;
    if (confirmModalConfig.onConfirm) {
      confirmModalConfig.onConfirm();
    }
    this.closeConfirmModal();
  }

  handleConfirmModalCancel() {
    this.closeConfirmModal();
  }

  closeConfirmModal() {
    this.setState({
      showConfirmModal: false,
      confirmModalConfig: {
        title: '',
        description: '',
        onConfirm: null,
        warning: '',
        itemType: '',
        quantity: 0
      }
    });
  }

  showConfirmModal(config) {
    this.setState({
      showConfirmModal: true,
      confirmModalConfig: config
    });
  }

  handleOpenRenameModal = (config) => {
    this.setState({
      showRenameModal: true,
      renameValue: config.value || '',
      renameConfig: {
        title: config.title || 'Rename',
        description: config.text || config.description || '',
        initialValue: config.value || config.initialValue || '',
        placeholder: config.placeholder || 'Enter name',
        checkOptions: config.checkOptions || null,
        onSubmit: config.onSubmit
      }
    });
  };



  handleCloseRenameModal = () => {
    this.setState({ showRenameModal: false });
  };

  handleRenameValueChange = (e) => {
    this.setState({ renameValue: e.target.value });
  };

  handleSaveRename = (newName, options) => {
    const { renameConfig } = this.state;

    if (renameConfig.onSubmit && newName?.trim()) {
      renameConfig.onSubmit(newName.trim(), options || { checkOptions: [] });
    }

    this.handleCloseRenameModal();
  };

  componentWillReceiveProps(props) {
    if (props.match.params?.groupId !== this.props.match.params?.groupId && this.props.match.params?.groupId) {
      this.loadGroup(props);
    }
  }
  componentWillUnmount() {
    // Clean up scroll listener to prevent memory leak
    if (this.scrollContainer && this.scrollHandler) {
      this.scrollContainer.removeEventListener('scroll', this.scrollHandler);
      this.scrollContainer = null;
      this.scrollHandler = null;
    }

    if (this._detailObserver) {
      this._detailObserver.disconnect();
      this._detailObserver = null;
    }
    if (this._detailResizeObserver) {
      this._detailResizeObserver.disconnect();
      this._detailResizeObserver = null;
    }
    if (this._scrollIntoViewTimer) {
      clearTimeout(this._scrollIntoViewTimer);
      this._scrollIntoViewTimer = null;
    }
    if (this._scrollRetryTimer) {
      clearTimeout(this._scrollRetryTimer);
      this._scrollRetryTimer = null;
    }


    this.setState({
      loadId: null,
      search: false,
      dragGroup: null,
      dragData: null,
      selectedTotal: '',
      selectedFilter: null,
      columnApi: null,
      listManagementUpgradeVisible: false,
      topRecords: [],
    })
  }


  getGridSearch() {
    const { id, name, selection } = this.props;
    const { selectedFilter, selectedTotal, columnApi } = this.state;
    const { items, allSelected, remainingSelected, selected } = selection.toJS();

    // Get columns in visual order, with pin position factored in.
    let cols = columnApi.getAllGridColumns().filter(c => c.visible && !['id', 'resultIndex'].includes(c.colDef.field));
    cols = cols.filter(c => c.pinned === 'left').concat(cols.filter(c => !c.pinned)).concat(cols.filter(c => c.pinned === 'right'));

    let sortModel = []
    const sortCol = columnApi?.getAllGridColumns()?.find((res) => res?.sort)
    if (sortCol && sortCol?.colId) {
      sortModel = [{ colId: sortCol.colId, sort: sortCol.sort }]
    }


    const regex = /property\/group\/(\d+)/;
    const matches = location.pathname.match(regex);
    let groupId = matches && matches.length > 0 ? matches[1] : 0;
    let getLatestid = id != groupId ? groupId : id;
    this.gridContext.groupId = groupId;

    const search = {
      id: getLatestid,
      name,
      filters: getFilters(this.api.getFilterModel(), cols),
      sortModel,
      allSelected,
      remainingSelected,
      selected,
      automationStatus: selectedTotal === '' ? null : !!Number(selectedTotal),
      valueCols: cols.map(({ colDef: { field, headerName, actualWidth } }) => ({ colId: field, headerName, width: actualWidth })),
      selectedIds: allSelected ? [] : Object.keys(items).filter(id => items[id]),
      unselectedIds: allSelected ? [] : Object.keys(items).filter(id => !items[id]),
    };

    if (selectedFilter) search.filters.push(getListingTypeFilter(selectedFilter));

    return search;
  }

  getFixedColumns() {
    return [
      { headerName: 'Id', field: 'id', width: 30, minWidth: 30, filter: false, cellRenderer: 'agGroupCellRenderer', headerComponent: 'blankHeader', pinned: 'left', sortable: false, suppressMovable: true },
      { headerName: '', field: 'resultIndex', width: 72, filter: false, minWidth: 72, pinned: 'left', headerComponent: 'indexHeaderRenderer', filterParams: { defaultOption: 'lessThanOrEqual', suppressAndOrCondition: true }, cellRenderer: 'indexCellRenderer', sortable: false, suppressMovable: true, suppressColumnsToolPanel: true },
      { headerName: 'Target List', field: 'groupName', width: 175, pinned: 'left', filter: 'agTextColumnFilter', suppressMovable: true, hide: this.props.id !== 1 || this.state?.selectedTotal === '' },
    ];
  }

  getColumnInfo(props, newLayout) {
    const { layouts, context } = props;

    let layout = newLayout;
    if (!layout) {
      const id = context.getIn(['info', 'gridLayoutId']);
      layout = layouts.find(l => l.id === id) || layouts.find(l => l.defaultLayout);
    }


    const fieldMap = layout && Array.isArray(layout.fields) ?
      layout.fields.reduce((m, f) => {
        if (f && f.name) {
          return { ...m, [f.name]: f };
        }
        return m;
      }, {}) : {};

    const columns = this.columns.map((c) => {
      const { name, seq, pin, width, hidden } = fieldMap[c.path] || {};
      return { ...c, ...(name ? { seq, pin, width, hidden } : {}) };
    }).sort((a, b) => a.seq - b.seq);

    const columnDefs = this.getFixedColumns().concat(mapFieldColumns(columns, this.columnPresets));
    columnDefs.forEach(itm => {
      if (itm.headerName === 'Last Sale Amount') {
        itm.filter = "agNumberColumnFilter"
      }
      if (itm.headerName === 'Year Built' || itm.headerName === 'Effective Year Built') {
        itm.filter = "agNumberColumnFilter"
      }
      if (itm.headerName === 'Mobile' || itm.headerName === 'Other' || itm.headerName === 'Landline') {
        itm.cellRenderer = (args) => <ContactCellRenderer {...args} inLine />
        itm.minWidth = 140;
        itm.filter = "agTextColumnFilter"
      }
      if (itm.headerName === 'Email') {
        itm.filter = "agTextColumnFilter"
      }

      if (itm.field === 'streetAddress') {
        itm.lockVisible = true;
        itm.hide = false;
        itm.suppressColumnsToolPanel = true; // optional
      }

      if (itm.field === 'id' && itm.cellRenderer !== 'agGroupCellRenderer') {
        itm.hide = true;
        itm.suppressColumnsToolPanel = true;
      }

      if (itm.headerName === 'Owner Occupied') {
        itm.filter = "agTextColumnFilter";
        itm.floatingFilter = true;
        itm.floatingFilterComponent = YesNoFloatingFilter;
        itm.floatingFilterComponentParams = { suppressFilterButton: true, displayNoSelectionAsAll: true };
      }

      if (itm.field === 'litigator') {
        itm.floatingFilterComponent = YesNoFloatingFilter;
        itm.floatingFilterComponentParams = { suppressFilterButton: true };
      }
    })
    return { columnDefs, layoutId: layout ? layout.id : null };
  }

  setLayout(props, layout, searchReset = false) {
    const { layoutId, columnDefs } = this.getColumnInfo(props, layout);

    this.setState({ layoutId }, () => {
      if (this.api) {
        this.api.setColumnDefs([]); // Required workaround for bug: https://github.com/ag-grid/ag-grid/issues/2889
        this.api.setColumnDefs(columnDefs);
      }

      this.search(searchReset);
    });
  }

  setActiveDetail(detail) {
    this.activeDetail = detail;
    this.gridContext.detailExpandField = null;
  }

  loadGroup(props = this.props) {
    const { history, loadGroupContext, groups, context } = props;
    const { selectedTotal, columnApi } = this.state;

    const regex = /property\/group\/(\d+)/;
    const matches = location.pathname.match(regex);
    let groupId = matches && matches?.length > 0 ? matches[1] : 0;
    this.gridContext.groupId = groupId;

    const loadId = Number(groupId) || 0;

    // Clear selection when group changes
    if (this.state.loadId !== loadId) {
      this.props.clearPropertySelection();
      this.lastSelectedId = null;

      if (this.api) {
        this.api.deselectAll();
      }
    }

    this.setState({
      loadId,
    })

    if (groups.size && i++ < 1000) {
      const group = groups.find(g => g.get('id') === loadId);

      if (!group) history.push(propertyGroupPath(0));
      else {
        if (columnApi) columnApi.setColumnVisible('groupName', loadId === 1 && selectedTotal !== '');
        if (!group.get('monitored') && selectedTotal !== '') this.setState({ selectedTotal: '' });

        // Update context to one that should be loaded.
        if (!context || context.get('id') !== loadId) {
          loadGroupContext(MAIN_CONTEXT, loadId, { filterEnabled: true });
        }

        // Correct context is loaded, now load proper layout and run search for this group
        else if (this.state.loadId !== loadId && context.get('size') == null) this.setState({ loadId }, () => this.setLayout(this.props, null, true));

        else if (context.get('size') != null) this.setState({ loadId: null });
      }
    }
  }

  confirmContactDeletion(quantity, callback) {
    // First close the current modal
    this.closeConfirmModal();

    // Then open the contact deletion modal
    setTimeout(() => {
      this.showConfirmModal({
        title: 'Confirm Contact Deletion',
        description: `Do you want to delete any contacts associated with ${quantity === 1 ? 'this property' : 'these properties'}?`,
        warning: '',
        submitText: 'Yes',
        cancelText: 'No',
        onConfirm: () => callback(true),
        onCancel: () => callback(false),
      });
    }, 100); // Small delay to ensure first modal is closed
  }

  search(reset = true) {
    if (this.api) {
      const { id } = this.props;
      this.lastSelectedId = null;

      const search = () => {
        this.gridContext.groupId = id;
        this.api.setServerSideDatasource({
          getRows: ({ request, fail, success }) => {
            const { searchGroupProperties, groupFilters, getGroupPropertyCounts } = this.props;
            const { selectedTotal } = this.state;
            const { startRow, endRow } = request;

            const requestGroupId = this.getCurrentRouteGroupId();
            const getGridSearchFilter = this.getGridSearch();

            searchGroupProperties(
              { ...getGridSearchFilter, startRow, endRow },
              id && groupFilters[selectedTotal].dirty,
              ({ response }) => {

                if (requestGroupId !== this.getCurrentRouteGroupId()) {
                  fail();
                  return;
                }

                const { properties = [] } = response;
                properties.forEach(itm => {
                  const ndaLabel = isNDAState(itm.stateCode) ? 'Est.' : '';
                  if (itm.lastSaleAmount) {
                    itm.lastSaleAmount = `${currencyFormat(itm.lastSaleAmount)} ${ndaLabel}`
                  }
                })
                const rowCount = (properties.length && properties[0].count) || 0;
                this.gridRowCount = rowCount;
                success({
                  rowData: properties,
                  rowCount,
                });
                if (!startRow && properties.length === 0) {
                  this.api.showNoRowsOverlay();
                } else {
                  this.api.hideOverlay();
                }
                getGroupPropertyCounts(getGridSearchFilter?.id);
                if (!startRow) this.setState({ topRecords: properties });
              },
              fail,
            );
          },
        });
      };

      if (!reset) search();
      else {
        this.api.setFilterModel(null);
        this.props.clearPropertySelection();
        this.setState({ selectedTotal: '', selectedFilter: null, topRecords: [] }, search);
      }
    }

  }

  updateSelection(items, remainingSelected) {
    const { setPropertySelection } = this.props;
    const totalRows = this.gridRowCount;
    const keys = Object.keys(items);
    const selected = keys.filter(i => items[i]).length + (remainingSelected ? totalRows - keys.length : 0);
    const allSelected = totalRows && selected === totalRows;

    setPropertySelection({ items, allSelected, selected: allSelected ? totalRows : selected, remainingSelected: allSelected || remainingSelected });
  }

  handleGridLayoutApply(layout) {
    this.setLayout(this.props, layout);
  }

  handleSkipClick() {
    const search = this.getGridSearch();
    if (!search.selected) return this.props.showAlert({
      title: 'No Records Selected',
      infoText: 'Please select one or more records before performing a Skip Trace.',
    });
    this.props.searchPropertyContacts(search, ({ response: contactIds }) => {
      this.handleSkipTracing(contactIds);
    });
  }

  handleSkipTracing(contactIds) {
    this.props.getAppendJobEstimate({ contactIds, appendMode: "BOTH", reprocessEnabled: false },
      ({ response, error }) => {
        if (error) {
          return;
        }
        const { message } = response || {};
        // if (!newQuantity || message?.includes("No contacts in your list are eligible")) {
        //     this.props.showAlert({
        //       title: "No Eligible Contacts Found",
        //       infoText: "Sorry, none of the selected contacts are eligible for Skip Trace. Please select different properties and try again.",
        //     });
        // }else
        if (message?.includes("There is an existing append job")) {
          this.props.showAlert({
            title: "Skip Trace in Progress",
            infoText: "There is a Skip Trace currently in progress. Please try again once it is complete.",
          });
        }
        else {
          this.props.skipTraceModal({
            groups: this.props.appendGroups,
            reprocessEnabled: false,
            contactIds,
          });
        }
      }
    );
  }

  handleNewCampaign(type) {
    const { searchPropertyContacts, createSmsCampaign, openAppendJobEditor, history, alert, context, openLaunchControlConfirmation, confirm, marketingCampaigns } = this.props;
    const search = this.getGridSearch();

    const formatType = (type = "") => type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
    // if (!search.selected) alert('Please select the record(s) you would like to market to.');
    if (!search.selected) return this.props.showAlert({
      title: 'No Records Selected',
      infoText: `Please select one or more records before initiating a ${formatType(type)} Campaign.`,
    });
    else if (type === 'SMS') {
      // Confirm with user whether to submit selected lead(s)
      confirm({
        caption: 'Send SMS (Beta)',
        okLabel: 'Confirm',
        cancelLabel: 'Cancel',
        question: `You are about to submit ${pluralize('property', search.selected, true)} to Launch Control for Texting`,
        onOk: () => {
          // User agreed, submit to server
          createSmsCampaign(search, ({ response: { redirectUrl, leadQuantity } }) => {
            // Successful response; open confirmation dialog if any were successfully sent, error message otherwise.
            if (leadQuantity) openLaunchControlConfirmation({ redirectUrl, leadQuantity });
            else alert('Oops, looks like the properties you selected do not have mobile numbers linked. *Only properties that are linked with mobile phone numbers are successfully transferred.');
          });
        },
      });
    } else if (type === 'DIALER') {
      // Shared with the Investor List and Investor Outreach's Actions dropdown
      // so the three entry points can't drift apart.
      const allowed = checkDialerCampaignAccess({
        profile: this.props.profile,
        lmEnabled: this.props.lmEnabled,
        isLegacyAccount: this.props.isLegacyAccount,
        openFullAccessRequiredModal: this.props.openFullAccessRequiredModal,
        closeFullAccessRequiredModal: this.props.closeFullAccessRequiredModal,
        openLeadAutomatorUpgrade: this.props.openLeadAutomatorUpgrade,
        leaveMessagePopup: this.props.leaveMessagePopup,
        history: this.props.history,
      });

      if (!allowed) return;

      this.openCampaignActivitySettingsModal(CAMPAIGN_ACTIVITY_TYPE.DIALER, search, searchPropertyContacts);
    } else if (type === 'POSTCARD') {
      this.openCampaignActivitySettingsModal(CAMPAIGN_ACTIVITY_TYPE.POSTCARD, search, searchPropertyContacts);
    } else if (type === 'DIRECT MAIL') {
      this.openCampaignActivitySettingsModal(CAMPAIGN_ACTIVITY_TYPE.DIRECT_MAIL, search, searchPropertyContacts);
    } else if (type === 'EMAIL') {
      this.openCampaignActivitySettingsModal(CAMPAIGN_ACTIVITY_TYPE.EMAIL, search, searchPropertyContacts);
    } else {
      searchPropertyContacts(search, ({ response: contactIds }) => {
        if (type === 'APPEND') openAppendJobEditor({ contactIds });
      });
    }
  }

  /**
   * Loads contact ids and marketing campaigns together, then opens the activity modal (PRD: concurrent fetches).
   */
  openCampaignActivitySettingsModal(activityType, search, searchPropertyContactsFn) {
    const { loadCampaigns, showAlert } = this.props;

    const contactsPromise = new Promise((resolve) => {
      searchPropertyContactsFn(search, ({ response: contactIds }) => {
        resolve(contactIds || []);
      });
    });

    Promise.all([contactsPromise, loadCampaigns()])
      .then(([contactIds]) => {
        if (contactIds.length === 0) {
          showAlert({
            title: 'No Leads Found',
            infoText: 'No leads were found for the selected records. Please adjust your selection and try again.',
          });
          return;
        }

        this.setState({
          pendingContactIds: contactIds,
          pendingActivityType: activityType,
          showActivitySettingsModal: true,
        });
      })
      .catch(() => {
        showAlert({
          title: 'Error',
          infoText: 'Could not load campaigns or contacts. Please try again.',
        });
      });
  }

  handleModalSave(name, marketingCampaignId) {
    const { createDialerCampaign, createDirectMailCampaign, getMarketingProfile, userId, history, showAlert, loadCampaign } = this.props;
    const { pendingActivityType, pendingContactIds } = this.state;
    const savedPropertyGroupId = this.props.context.get('id');

    if (pendingActivityType === CAMPAIGN_ACTIVITY_TYPE.DIALER) {
      createDialerCampaign({
        name,
        marketingCampaignId,
        contactIds: pendingContactIds,
        originatingListName: this.props.name,
      })
        .then((res) => {
          const dialerId = res && res.id;
          if (!dialerId) {
            throw new Error('Invalid dialer response');
          }
          this.setState({
            showActivitySettingsModal: false,
            pendingActivityType: null,
            pendingContactIds: [],
          });
          history.push(`/campaign/${marketingCampaignId}/dialer/${dialerId}`);
          loadCampaign(marketingCampaignId);
        })
        .catch(() => {
          this.setState({ showActivitySettingsModal: false, pendingActivityType: null, pendingContactIds: [] });
          showAlert({
            title: 'Error',
            infoText: 'Could not create the dialer activity. Please try again.',
          });
        });
    } else if (pendingActivityType === CAMPAIGN_ACTIVITY_TYPE.POSTCARD) {
      history.push({
        pathname: `/campaign/${marketingCampaignId}/postcard/0`,
        state: { contactIds: pendingContactIds, savedPropertyGroupId, name, marketingCampaignId },
      });
      this.setState({
        showActivitySettingsModal: false,
        pendingActivityType: null,
        pendingContactIds: [],
      });
    } else if (pendingActivityType === CAMPAIGN_ACTIVITY_TYPE.EMAIL) {
      history.push({
        pathname: `/campaign/${marketingCampaignId}/email/settings`,
        state: { contactIds: pendingContactIds, savedPropertyGroupId, name, marketingCampaignId },
      });
      this.setState({
        showActivitySettingsModal: false,
        pendingActivityType: null,
        pendingContactIds: [],
      });
    }
    else if (pendingActivityType === CAMPAIGN_ACTIVITY_TYPE.DIRECT_MAIL) {

      const handler = new CreateDirectMailHandler(
        userId,
        { id: marketingCampaignId, contactIds: pendingContactIds },
        null,
        createDirectMailCampaign,
        getMarketingProfile
      );

      return handler.run()
        .then((res) => {
          console.log("DIRECT MAIL RESPONSE", res);
          this.setState({
            showActivitySettingsModal: false,
            pendingActivityType: null,
            pendingContactIds: [],
          });

          history.push({
            pathname: `/campaign/${marketingCampaignId}/directmail`,
            state: {
              isNewCampaign: true,
              newCampaign: res,
            },
          });

          loadCampaign(marketingCampaignId);

          return res;
        })
        .catch((err) => {

          console.error("DIRECT MAIL ERROR => ", err);

          this.setState({
            showActivitySettingsModal: false,
            pendingActivityType: null,
            pendingContactIds: [],
          });

          showAlert({
            title: 'Error',
            infoText: 'Could not create direct mail campaign. Please try again.',
          });

          throw err;
        });
    }
  }

  handleGenerateMailingLabels() {
    const { alert, openMailingLabels } = this.props;
    const propertySearch = this.getGridSearch();

    if (!propertySearch.selected) alert('Please select the record(s) you would like to print.');
    else openMailingLabels({ propertySearch });
  }

  handleSelect(id, selected, ev) {
    const { selection, searchGroupProperties } = this.props;
    const items = selection.get('items').toJS();

    // If no ID is provided then it's a select all. Toggle all items to indicated status.
    if (!id) Object.keys(items).forEach((i) => { items[i] = selected; });
    else {
      // If this is not a range selection (range = shift pressed), the item selected (potential beginning of range), or clicking the last selected item again, then toggle single item.
      if (!ev.shiftKey || !this.lastSelectedId || id === this.lastSelectedId) items[id] = selected;
      else {

        const startId = Math.min(id, this.lastSelectedId);
        const endId = Math.max(id, this.lastSelectedId);

        // Iterate through rows and toggle the selection status of any whose row index is within range
        Object.keys(items).forEach((i) => {
          if (i >= startId && i <= endId) {
            items[i] = selected;
          }
        });
      }

      // Record last selected item's ID, potentially to be referenced as the beginning of a range selection.
      this.lastSelectedId = id;
    }

    this.updateSelection(items, (!id && selected) || (id && selection.get('remainingSelected')));
  }

  getCurrentRouteGroupId() {
    const regex = /property\/group\/(\d+)/;
    const matches = location.pathname.match(regex);
    const groupId = matches && matches.length > 0 ? matches[1] : 0;
    const parsed = Number(groupId);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  handleGridModelUpdated() {
    if (this.api) {
      const { selection } = this.props;
      const items = selection.get('items').toJS();
      const remainingSelected = selection.get('remainingSelected');

      // Update any newly-retried records with the "remainingSelected" selection status. Represents the "select all" for non-loaded records,
      // which generally won't have their ID in the current selection map (but can possibly if there was a big range selection).
      this.api.forEachNode(({ data: { id } = {} }) => {
        if (id) items[id] = id in items ? items[id] : remainingSelected;
      });

      this.updateSelection(items, remainingSelected);
    }
  }

  handleMarketingCellClicked(params) {
    const { value, node, colDef: { field } } = params;
    if (value) {
      if (!node.expanded) {
        this.gridContext.detailExpandField = field;
        node.setExpanded(true);
      } else if (this.activeDetail) this.activeDetail.loadField(field);
    }
  }

  handleGridRowGroupOpened(params) {
    if (this.processingRows || !params.node.expanded) return;

    // AG Grid repositions every row below a collapsed row (via translateY) without
    // adjusting scrollTop. Collapsing the previously-open row here is what powers the
    // "only one detail open at a time" behavior, but when that row sits above the
    // current viewport, closing it visually yanks the whole list upward by its height.
    // Track how much height disappears above the viewport so it can be compensated for
    // once the collapse/expand settles.
    const scrollContainer = this.scrollContainer;
    const scrollTopBefore = scrollContainer ? scrollContainer.scrollTop : null;
    let heightRemovedAboveViewport = 0;

    this.processingRows = true;
    this.api.forEachNode((node) => {
      if (node.expanded && node.data.id !== params.data.id) {
        const { detailNode } = node;
        if (
          scrollTopBefore != null && detailNode &&
          detailNode.rowTop != null && detailNode.rowHeight != null &&
          (detailNode.rowTop + detailNode.rowHeight) <= scrollTopBefore
        ) {
          heightRemovedAboveViewport += detailNode.rowHeight;
        }
        node.setExpanded(false);
      }
    });
    this.processingRows = false;

    // Update detail position after row expansion, using requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      if (scrollContainer && heightRemovedAboveViewport) {
        scrollContainer.scrollTop = Math.max(0, scrollTopBefore - heightRemovedAboveViewport);
      }
      this.updateDetailPosition();
      this.scheduleScrollIntoView();
    });
  }

  /**
   * Closes the open property-detail row, if there is one, and tears down the work that was
   * scheduled for it.
   *
   * Switching groups swaps the grid's server-side datasource and purges its rows, but AG Grid
   * keeps the previously-expanded row's detail panel mounted in the shared
   * '.ag-full-width-container' until the new block of rows actually comes back from the server.
   * Because updateDetailPosition() positions that panel with its own translateY, it stayed
   * parked on screen — the old property's table floating over the loading list — for as long as
   * the request took. Collapsing here, before the group's own load is kicked off, makes it
   * disappear with the click that changed the group instead.
   */
  collapseExpandedDetail() {
    if (this._scrollIntoViewTimer) {
      clearTimeout(this._scrollIntoViewTimer);
      this._scrollIntoViewTimer = null;
    }
    if (this._scrollRetryTimer) {
      clearTimeout(this._scrollRetryTimer);
      this._scrollRetryTimer = null;
    }

    // Stop tracking the outgoing panel's size — otherwise its teardown resize fires
    // scrollExpandedRowIntoView against a row that no longer exists. updateDetailPosition()
    // re-targets this observer at the next detail panel whenever one is opened.
    if (this._detailResizeObserver && this._detailResizeObserver._observedEl) {
      this._detailResizeObserver.disconnect();
      this._detailResizeObserver._observedEl = null;
    }

    this.activeDetail = null;
    this.gridContext.detailExpandField = null;

    if (!this.api) return;

    // Same guard the "only one detail open at a time" collapse in handleGridRowGroupOpened
    // uses, so the two paths can't interleave if a row-group event is already in flight.
    this.processingRows = true;
    this.api.forEachNode((node) => {
      if (node.expanded) node.setExpanded(false);
    });
    this.processingRows = false;
  }

  handleGridDetail(params) {
    const { data: { id }, successCallback } = params;

    this.props.getSavedPropertyDetail(id, ({ response }) => { successCallback(response); });
  }

  getContextMenuItems() {
    const { selection } = this.props;
    // PROPS-3385: right-clicking without selecting any properties used to leave
    // Export (and its CSV/Excel sub-options) fully enabled, which could surface a
    // stale "out of saves" flow. Grey out the whole Export row when nothing is checked.
    const hasSelection = !!selection.get('selected');

    const result = [
      'copy',
      'copyWithHeaders',
      'paste',
      'separator',
      {
        name: 'Export',
        disabled: !hasSelection,
        tooltip: hasSelection ? undefined : 'Select at least one property to export',
        subMenu: [
          {
            name: 'CSV Export',
            disabled: !hasSelection,
            action: () => {
              this.handleExport(true);
            },
            icon: '<span class="ag-icon ag-icon-csv" unselectable="on" role="presentation"></span>',
          },
          {
            name: 'Excel Export (.xlsx)',
            disabled: !hasSelection,
            action: () => {
              this.handleExport(false);
            },
            icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
          },
          {
            name: 'Excel Export (.xml)',
            disabled: !hasSelection,
            action: () => {
              this.handleExport(true, true);
            },
            icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
          },
        ],
        icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
      },

    ];

    return result;
  }

  handleOpenContractManager() {
    this.props.openContractManager();
  }

  handleImport() {
    const { overdueAccount } = this.props.profile;
    const { planDetails } = this.props;
    if (overdueAccount) {
      const currentPlan = planDetails && planDetails.accountEnrolledPlans && planDetails.accountEnrolledPlans.find(plan => plan.active);
      const total = currentPlan ? currentPlan.quantity : 0;
      this.props.leaveMessagePopup({
        title: "Subscription Past Due",
        message: `Your subscription is past due, and no new properties can be saved. Upgrade now to access the full ${total}.`,
        yesLable: "Upgrade",
        cancelLable: "Cancel",
        yesRedirect: () => {
          // Open the Activate Subscription popup
          this.props.openAccountUpgrade();
        },
      })
    }
    else if (this.props.usageSectionDetails?.id && this.props.usageSectionDetails?.savesRemaining <= 0) {
      this.props.leaveMessagePopup({
        title: "Not Enough Save Credits",
        message:
          "You don’t have enough save credits to perform this action. Please purchase additional credits to continue.",
        yesLable: "Purchase Credits",
        cancelLable: "Cancel",
        yesRedirect: () => {
          // Open the Activate Subscription popup
          this.purchaseSavesAndExportsPopup();
        },
      })
    }
    else this.props.openImport();
  }

  purchaseSavesAndExportsPopup() {
    const { purchaseSavesAndExportsPopup, usageSectionDetails } = this.props;
    purchaseSavesAndExportsPopup(usageSectionDetails);
  };

  // The CustomFilterModal's Lead List tiles mirror the group's CarouselTile set
  // (the enabled group filter types for the selected total), rendered 1:1:
  // label = name, value = the filter's listingType, count = the tile's cached
  // quantity (same count the CarouselTile shows).
  // Just Sold / Low Equity / Neg Equity are excluded here (see
  // NON_LEAD_LIST_TYPES) so the picker matches the canonical Lead List set.
  // value falls back to the group's `type` when `filter.listingType` is absent
  // (e.g. Bank Owned, whose filter is a foreclosureStatus2 clause) — this matches
  // the canonical catalog's value for that lead list ('F') instead of undefined.
  // On Market keeps its special-case value ('M') since filter.listingType is set.
  getGroupLeadListOptions() {
    const { groupFilters } = this.props;
    const { selectedTotal } = this.state;
    const laAvailable = isLaAvailable();

    return ((groupFilters[selectedTotal] && groupFilters[selectedTotal].filters) || [])
      .filter(t => (laAvailable || !t.disabled) && !NON_LEAD_LIST_TYPES.includes(t.type))
      .map(t => ({ label: t.name, value: (t.filter && t.filter.listingType) || t.type, count: t.quantity }));
  }

  handleViewFilter(editMode = false) {
    const { openSearchFilterViewer, saveGroupSearch, getGroupSearch, id, monitored, lmEnabled } = this.props;

    getGroupSearch(id, ({ response }) => {
      openSearchFilterViewer({
        search: response,
        editMode,
        editEnabled: lmEnabled && monitored,
        leadListOptions: this.getGroupLeadListOptions(),
        onSave: (search, onSuccess) => {
          const s = search.toJS();
          const type = s.listingType;

          saveGroupSearch(id, { ...s, listingType: Array.isArray(type) ? type[0] : type }, () => {
            onSuccess();
            this.search(false);
          });
        },
      });
    });
  }

  handleEditFilter() {
    const { openCustomFilterModal, saveGroupSearch, getGroupSearch, id, monitored, lmEnabled } = this.props;

    getGroupSearch(id, ({ response }) => {
      openCustomFilterModal({
        search: response,
        mode: 'list',
        editEnabled: lmEnabled && monitored,
        leadListOptions: this.getGroupLeadListOptions(),
        onSave: (search, onSuccess) => {
          const s = search.toJS();
          const type = s.listingType;

          saveGroupSearch(id, { ...s, listingType: Array.isArray(type) ? type[0] : type }, () => {
            onSuccess();
            this.search(false);
          });
        },
      });
    });
  }

  handleEditGroupFilter(filterType) {
    const { openCustomFilterModal, savePropertyGroupFilter, deletePropertyGroupFilter, id, groupFilters } = this.props;
    const { selectedTotal } = this.state;

    const { filter, customFilter } = groupFilters[selectedTotal].filters.find(f => f.type === filterType);

    openCustomFilterModal({
      search: customFilter || filter,
      mode: 'summary',
      leadListOptions: this.getGroupLeadListOptions(),
      onSave: (search, onSuccess) => {
        const s = search.toJS();
        const type = s.listingType;

        return savePropertyGroupFilter({
          ...s,
          filterType,
          savedPropertyGroupId: id,
          listingType: Array.isArray(type) ? type[0] : type,
        }, () => {
          onSuccess();
          this.search(false);
        });
      },
      onDelete: !customFilter ? null : (onSuccess) => {
        // Deletes the filter if customFilter exists, and then calls onSuccess
        deletePropertyGroupFilter(customFilter.id, () => {
          onSuccess();
          this.search(false);
        });
      },
    });
  }

  handleRemove(selection = {}) {
    const { deleteGroupProperties, context, id } = this.props;
    const search = { ...this.getGridSearch(), ...selection };
    const qty = search.selected;

    this.setState({
      removePropertyModal: {
        onConfirm: () => this.confirmContactDeletion(qty, deleteContacts => deleteGroupProperties(search, deleteContacts, false, () => this.search(false))),
      },
    });
  }

  handleRemovePropertyConfirm() {
    const { removePropertyModal } = this.state;
    this.setState({ removePropertyModal: null });
    if (removePropertyModal?.onConfirm) removePropertyModal.onConfirm();
  }

  handleRemovePropertyCancel() {
    this.setState({ removePropertyModal: null });
  }

  handleRemoveDuplicates() {
    const { confirmRemoval, deleteGroupProperties, id } = this.props;
    const search = { ...this.getGridSearch() };

    confirmRemoval({
      itemType: 'Property',
      question: id ? 'Notice - By removing duplicate properties, all Properties selected in this list will remain and any duplicate property in other lists will be deleted. Once deleted it cannot be recovered unless re-saved.' : 'Notice - By removing duplicate properties, The first list a property was saved to will remain and all other duplicates will be deleted. Once deleted it cannot be recovered unless re-saved.',
      warning: deleteWarning,
      onOk: () => deleteGroupProperties(search, true, true, () => this.search(false)),
    });
  }

  handleDeleteGroup(id) {
    const { confirmRemoval, groups, context, deletePropertyGroup, history } = this.props;
    const group = groups.find(g => g.get('id') === (id || context.get('id')));

    const qty = group.get('size');
    const itemType = groupTypeName(group);

    const regex = /property\/group\/(\d+)/;
    const matches = location.pathname.match(regex);
    let groupId = matches && matches.length > 0 ? matches[1] : null;

    const doDelete = (deleteContacts = false) => {
      deletePropertyGroup(group.get('id'), deleteContacts, null, ({ response: { groups } }) => {
        if (Number(groupId) === group.get('id')) {
          history.push(propertyGroupPath(0))
        }
      })
    }

    this.showConfirmModal({
      title: `Confirm ${itemType} Removal`,
      description: `Are you sure you want to remove ${itemType.toLowerCase()} <strong>${group.get('name')}</strong>?${qty ? ` The ${qty === 1 ? 'property' : `${qty} properties`} under this ${itemType.toLowerCase()} will be removed.` : ''}`,
      warning: deleteWarning,
      onConfirm: () => (!qty ? doDelete() : this.confirmContactDeletion(qty, doDelete)),
    });
  }

  handleDeleteDrop() {
    const { confirmRemoval, deletePropertyGroup } = this.props;
    const { dragGroup: { id, name }, dragData: { listingType, quantity, recordId, type, key, selected } } = this.state;

    if (listingType) {
      const { label, value } = listingType;
      confirmRemoval({
        question: `Are you sure you want to remove the ${pluralize(`${label} record`, quantity, quantity > 1)} from '${name}'?`,
        warning: deleteWarning,
        onOk: () => this.confirmContactDeletion(quantity, deleteContacts => deletePropertyGroup(id, deleteContacts, value)),
      });
    } else if (recordId) this.handleRemove(selected ? {} : getSingleRecordSelection(recordId));
    else if (type === 'FOLDER') this.handleDeleteFolder(key);
    else this.handleDeleteGroup(id);
  }

  handleGroupDrop(targetId, type) {
    const { groups, confirm } = this.props;
    const { dragGroup: { id, name: groupName, size: groupSize }, dragData: { listingType: { label, value: listingType } = {}, quantity: size, recordId, selected } } = this.state;
    const name = targetId ? groups.find(g => g.get('id') === Number(targetId)).get('name') : null;

    let text;
    let search;

    // Property drag
    if (recordId) search = selected ? this.getGridSearch() : getSingleRecordSelection(recordId);

    // Group drag
    else if (!listingType) search = { selected: groupSize, allSelected: true };

    // Listing Type drag (otherwise it's a group drag)
    else {
      text = ` ${label} record`;
      search = { filters: [getListingTypeFilter(listingType)], selected: size, allSelected: true };
    }

    search.id = id;
    search.name = groupName;
    search.records = pluralize(text || `${selected ? 'selected ' : ''}property`, search.selected, search.selected > 1);

    text = `${search.records}${text || recordId ? '' : ` from '${groupName}'`}`;
    text = targetId ? `Add the ${text} to '${name}'?` : `The ${text} will be added to this new ${groupTypeName(type)}.`;

    if (!targetId) this.handleAddGroup(type, search, text);
    else {
      confirm({
        caption: pluralize('Add Property', search.selected),
        okLabel: 'Yes',
        cancelLabel: 'No',
        question: text,
        checkOptions: search.id < 100 ? null : [{ id: 'delete', label: `Delete the ${search.records} from '${groupName}'.` }],
        onOk: ({ checkOptions }) => this.saveGroup(search, type, name, !!(checkOptions.length && checkOptions[0].checked)),
      });
    }
  }

  handleDragStart(dragData = {}) {
    const { groups, context } = this.props;
    const { id, name, size } = groups.find(g => g.get('id') === ((dragData.type === 'ITEM' && dragData.id) || context.get('id'))).toJS();

    // Store the source drag data, which describes the item being dragged, as well as details of the pertinent group. If a group is being dragged,
    // then grab its info. If not, then use the currently selected group. This group info is used to prevent dropping items into the same group or parent group.
    this.setState({ dragData, dragGroup: { id, name, size }, isDropActive: true });
  }

  handleDragEnd() {
    this.setState({ dragGroup: null, dragData: null, isDropActive: false });
  }

  handleExport(csv, isXML = false) {
    const { exportGroupProperties, context, openExportPropertyConfirmation } = this.props;
    exportGroupProperties(this.getGridSearch(), context.getIn(['info', 'name']), csv, isXML, ({ response }) => {
      response.isXML = isXML;
      openExportPropertyConfirmation({ exportResponse: response });
    });
  }

  handleRename() {
    const { context, saveGroupProperties } = this.props;

    this.handleOpenRenameModal({
      title: 'Rename List',
      description: 'Please enter a new name for this group.',
      initialValue: context.getIn(['info', 'name']),
      placeholder: 'Enter list name',
      onSubmit: (name, options) => {
        saveGroupProperties({ id: context.get('id'), name });
      },
    });
  }

  handleTotalClick(type) {
    const { selectedTotal, selectedFilter } = this.state;
    if (type !== selectedTotal || !!selectedFilter) this.setState({ selectedTotal: type, selectedFilter: type === selectedTotal ? null : selectedFilter }, () => this.search(false));
  }

  handleFilterClick(type) {
    const { selectedFilter } = this.state;
    this.setState({ selectedFilter: selectedFilter === type ? null : type }, () => this.search(false));
  }

  handleAddGroup(type, search, text) {
    this.handleOpenRenameModal({
      title: `Add New ${groupTypeName(type)}`,
      description: text || '',
      initialValue: '',
      placeholder: 'Enter name',
      checkOptions: !search || search.id < 100 ? null : [{
        id: 'delete',
        label: `Delete the ${search.records} from '${search.name}'.`,
        checked: false
      }],
      onSubmit: (name, options) => {
        const deleteOriginal = options?.checkOptions?.length > 0 && options.checkOptions[0]?.checked;
        this.saveGroup(search, type, name, deleteOriginal);
      },
    });
  }

  handleAddToGroup(type) {
    const { id, name, alert, groups, openAddToGroup, openAddToMarketingListModal } = this.props;
    const search = this.getGridSearch();
    const { selected: size, automationStatus } = search;
    const monitored = type === PropertyGroupTypes.MONITORED;

    const checkOptions = id < 100 ? null : [{
      id: 'delete',
      label: `Delete the selected ${pluralize('property', size, size > 1)} from '${name}'.`
    }];

    if (!size) {
      this.props.showAlert({
        title: 'No Records Selected',
        infoText: 'Please select one or more records you would like to add.',
      });
    } else {
      openAddToMarketingListModal({
        title: `Add to ${groupTypeName(type)}`,
        size,
        hideSkipTraceOption: true,
        checkOptions,
        groups: groups.filter(
          g =>
            (automationStatus || g.get('id') !== id) &&
            g.get('type') === type &&
            !g.get('standard')
        ),
        onSave: (name, onComplete, saveOptions) => {
          const deleteOriginal = !!(saveOptions?.checkOptions && saveOptions.checkOptions.length > 0);

          this.saveGroup(
            search,
            monitored && saveOptions?.selection
              ? saveOptions.selection.originalType
              : type,
            name,
            deleteOriginal,
            () => onComplete(size),
            saveOptions?.id
          );
        }
      });
    }
  }

  handleAddFolder(type) {
    const { openAddToFolder, folders, savePropertyFolder } = this.props;

    openAddToFolder({
      folders: folders.toJS(),
      type,
      editMode: true,
      onSubmit: folder => savePropertyFolder(folder),
    });
  }

  handleAddToFolder() {
    const { openAddToFolder, folders, context, savePropertyFolder } = this.props;

    const { id, type, folderKey } = context.get('info').toJS();

    openAddToFolder({
      folders: folders.toJS(),
      type,
      folderKey,
      onSubmit: folder => savePropertyFolder(folder, id),
    });
  }

  handleDeleteFolder(key) {
    const { context, deletePropertyFolder, confirmRemoval, folders } = this.props;
    const folderKey = key || context.getIn(['info', 'folderKey']);
    const folder = folders.find(f => f.get('key') === folderKey);

    // confirmRemoval({
    //   itemType: 'Folder',
    //   question: `Are you sure you want to remove the "${folder.get('name')}" folder? This will not delete any of your lists or saved properties.`,
    //   onOk: () => deletePropertyFolder(folderKey.substr(1)),
    // });

     this.showConfirmModal({
      title: `Confirm Folder Removal`,
      description: `<div>Are you sure you want to remove the "${folder.get('name')}" folder? <div style="margin-top: 10px;">This will not delete any of your lists or saved properties. Only the folder will be removed, and any lists and folders inside this folder will be moved to the top level before it is deleted.</div></div>`,
      onConfirm: () => deletePropertyFolder(folderKey.substr(1)),
    });
  }

handleEditFolder(key) {
  const { openAddToFolder, folders, context, savePropertyFolder, showAlert } = this.props;

  // Determine the folder key
  let folderKey = key;
  if (!folderKey && context) {
    // Try to get folderKey from context
    if (context.getIn) {
      folderKey = context.getIn(['info', 'folderKey']);
    } else if (context.info) {
      folderKey = context.info.folderKey;
    }
  }

  if (!folderKey) {
    console.error('No folder key found for edit operation');
    if (showAlert) {
      showAlert({
        title: 'Error',
        infoText: 'Unable to identify which folder to edit.',
      });
    }
    return;
  }

  // Get folders as array
  let foldersArray = [];
  if (folders) {
    if (folders.toJS) {
      foldersArray = folders.toJS();
    } else if (Array.isArray(folders)) {
      foldersArray = folders;
    }
  }

  // Find the folder - try multiple ways to match the key
  let folder = null;
  let matchedKey = folderKey;

  // Try 1: Direct match
  folder = foldersArray.find(f => f.key === folderKey);

  // Try 2: If folderKey starts with "folder-", try without the prefix
  if (!folder && folderKey.startsWith('folder-')) {
    const keyWithoutPrefix = folderKey.replace('folder-', '');
    folder = foldersArray.find(f => f.key === keyWithoutPrefix || f.key === parseInt(keyWithoutPrefix, 10));
    if (folder) matchedKey = folder.key;
  }

  // Try 3: If folderKey is a number, try as string
  if (!folder && !isNaN(folderKey)) {
    const keyAsString = String(folderKey);
    folder = foldersArray.find(f => f.key === keyAsString);
    if (folder) matchedKey = folder.key;
  }

  // Try 4: If folderKey is a string that looks like a number, try as number
  if (!folder && !isNaN(parseInt(folderKey, 10))) {
    const keyAsNumber = parseInt(folderKey, 10);
    folder = foldersArray.find(f => f.key === keyAsNumber);
    if (folder) matchedKey = folder.key;
  }

  // Try 5: Look for folder by checking if the key is in the key with "folder-" prefix
  if (!folder) {
    folder = foldersArray.find(f => `folder-${f.key}` === folderKey);
    if (folder) matchedKey = folder.key;
  }

  // If folder is not found, show an error and return
  if (!folder) {
    console.error('Folder not found with key:', folderKey, 'Available folders:', foldersArray.map(f => f.key));
    if (showAlert) {
      showAlert({
        title: 'Error',
        infoText: `The folder you are trying to edit could not be found.`,
      });
    }
    return;
  }

  // Get the folder type
  const folderType = folder.type;

  openAddToFolder({
    folders: foldersArray,
    type: folderType,
    folderKey: matchedKey, // Use the matched key
    editMode: true,
    onSubmit: (updatedFolder) => savePropertyFolder(updatedFolder),
  });
}

  handleGridReady({ api, columnApi }) {
    this.api = api;
    this.gridContext.api = api;
    this.search();
    this.setState({ columnApi });
    this.handleDetailPosition();


    // Update position on scroll to handle scrolling issues
    // Use setTimeout to ensure grid DOM is fully rendered before accessing it
    setTimeout(() => {
      // Scoped to this instance's own grid wrapper — see the comment in componentDidMount
      // on why an unscoped document query is unsafe here.
      const scrollContainer = this.gridWrapperEl ? this.gridWrapperEl.querySelector('.ag-body-viewport') : null;
      if (scrollContainer) {
        this.scrollContainer = scrollContainer;


        // Create throttled scroll handler using requestAnimationFrame
        let scrollUpdateScheduled = false;
        this.scrollHandler = () => {
          if (!this.api) return;


          // Throttle: only schedule one update per frame
          if (!scrollUpdateScheduled) {
            scrollUpdateScheduled = true;
            requestAnimationFrame(() => {
              scrollUpdateScheduled = false;
              this.updateDetailPosition();
            });
          }
        };


        scrollContainer.addEventListener('scroll', this.scrollHandler);
      }
    }, PropertyGroup.GRID_DOM_READY_DELAY_MS);
  }

  handleOpenMap() {
    this.props.openMap({ properties: this.state.topRecords, groupName: this.props.name });
  }

  saveGroup(search, type, name, deleteOriginal = false, afterSuccess, groupId) {
    const { saveGroupProperties, history, id } = this.props;
    const group = groupId ? { id: groupId, type, name } : { type, name };
    saveGroupProperties(group, search, deleteOriginal, ({ response: { groups } }) => {
      if (afterSuccess) afterSuccess();

      // Manually trigger a grid refresh if the same group is being modified; it will happen automatically if switching groups.
      if (id === groups.find(g => g.modified).id) this.search(false);
      else history.push(propertyGroupPath(0));
    });
  }

  updateDetailPosition() {
    if (!this.api || !this.gridWrapperEl) return;

    let expandedNode = null;
    this.api.forEachNode((node) => {
      if (node.expanded) {
        expandedNode = node;
      }
    });

    if (!expandedNode) return;

    // AG Grid can render more than one '.ag-full-width-container' within this instance
    // (e.g. one reserved for pinned rows), and which one actually receives the live detail
    // content for a given expand is not a stable index — find it by content, not position.
    //
    // The detail row renders into a single shared "full width row" container that AG Grid
    // reuses for whichever row is currently expanded. React doesn't swap that container's
    // content synchronously with the row-model change, so there's a window where it still
    // holds the PREVIOUS row's rendered DetailCellRenderer while AG Grid's model already
    // reports a DIFFERENT row as expanded. Repositioning by row math alone in that window
    // moves the old row's still-visible content to the new row's slot ("the old table
    // comes down") and leaves its original spot blank. Comparing the rendered id
    // (data-property-id, stamped by DetailCellRenderer) against the currently-expanded
    // node confirms the content actually belongs there before touching its position —
    // otherwise bail and leave it where it is; the next DOM mutation (React finishing the
    // swap) retries this via the MutationObserver.
    const containers = [...this.gridWrapperEl.querySelectorAll('.ag-full-width-container')];
    const container = containers.find((c) => {
      const el = c.firstChild && c.firstChild.querySelector && c.firstChild.querySelector('[data-property-id]');
      return el && String(el.dataset.propertyId) === String(expandedNode.data.id);
    });
    if (!container || !container.firstChild) return;

    const renderedDetail = container.firstChild.querySelector('[data-property-id]');
    if (!renderedDetail) return;

    // Watch the actual rendered detail content for size changes (data loading in, tab
    // switches, section toggles) so scrollExpandedRowIntoView can react once its real
    // height is known, not just its initial loading-placeholder height. Re-targeting on
    // every call is safe/cheap — disconnect() only affects this observer's own tracking.
    if (this._detailResizeObserver && this._detailResizeObserver._observedEl !== renderedDetail) {
      this._detailResizeObserver.disconnect();
      this._detailResizeObserver.observe(renderedDetail);
      this._detailResizeObserver._observedEl = renderedDetail;
    }

    // Get exact pixel position from AG Grid
    const rowTop = expandedNode.rowTop;
    const rowHeight = expandedNode.rowHeight;


    // Ensure we have valid values using strict equality
    if (rowTop === null || rowTop === undefined || rowHeight === null || rowHeight === undefined) return;


    const position = rowTop + rowHeight;
    container.firstChild.style.transform = `translateY(${position}px)`;
  }

  /**
   * Brings a newly-expanded row's Tab Details panel into view — but only by the minimum
   * amount needed, and only if it isn't already fully visible.
   *
   * Deliberately does NOT use AG Grid's row-model geometry (rowTop/rowHeight/detailNode
   * height): with detailRowAutoHeight, AG Grid's own row-wrapper height is recalculated
   * through AutoHeightService's onRowHeightChanged, which is debounced ~100ms behind the
   * actual rendered content. Reading that wrapper's height right when the real content
   * resizes (which is when this runs, via the ResizeObserver on the rendered detail)
   * yields a stale, too-small number — undershooting the scroll and leaving the bottom of
   * the panel cut off. Measuring the real element's own getBoundingClientRect() instead is
   * always current, independent of AG Grid's internal bookkeeping.
   */
  scrollExpandedRowIntoView(retriesLeft = PropertyGroup.SCROLL_INTO_VIEW_MAX_RETRIES) {
    if (this._scrollRetryTimer) {
      clearTimeout(this._scrollRetryTimer);
      this._scrollRetryTimer = null;
    }

    const scrollContainer = this.scrollContainer;
    if (!this.api || !scrollContainer) return;

    let expandedNode = null;
    this.api.forEachNode((node) => {
      if (node.expanded) expandedNode = node;
    });
    if (!expandedNode) return;

    // Search every full-width container within THIS instance's own grid wrapper, rather
    // than assuming a fixed index or querying the whole document — AG Grid can render more
    // than one '.ag-full-width-container' per instance (e.g. for pinned rows), and the app
    // can keep another instance of this page mounted off-screen, which renders its own
    // matching elements too.
    if (!this.gridWrapperEl) return;
    const renderedDetail = [...this.gridWrapperEl.querySelectorAll('.ag-full-width-container [data-property-id]')]
      .find(el => String(el.dataset.propertyId) === String(expandedNode.data.id));
    if (!renderedDetail) return;

    const detailRect = renderedDetail.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const EDGE_PADDING = 8; // small breathing room so the revealed edge isn't flush against the viewport

    if (detailRect.top < containerRect.top) {
      // Top of the panel has scrolled above the viewport — reveal it with a minimal,
      // relative adjustment (scrolls up by exactly the hidden amount).
      scrollContainer.scrollTop += detailRect.top - containerRect.top;
    } else if (detailRect.bottom > containerRect.bottom) {
      // Bottom of the panel is below the viewport — scroll down by exactly the hidden
      // amount (plus a small padding), capped so we never scroll past the point where the
      // panel's own top would leave view (relevant when the panel is taller than the
      // viewport itself — then show as much as possible starting from its top).
      const hiddenBelow = detailRect.bottom - containerRect.bottom + EDGE_PADDING;
      const maxScroll = Math.max(0, detailRect.top - containerRect.top);
      scrollContainer.scrollTop += Math.min(hiddenBelow, maxScroll);

      // AG Grid's detailRowAutoHeight recalculates the expanded row's real height — and
      // therefore this container's scrollHeight, which caps how far scrollTop can actually
      // move — on its own debounce (~100ms, AutoHeightService), independent of the rendered
      // content's own resize this method reacts to. If that hasn't landed yet, scrollHeight
      // isn't tall enough yet either, so the write above silently clamps short of the target.
      // Re-measure a few times, spaced past that debounce, until the panel is fully visible
      // or retries run out.
      if (retriesLeft > 0) {
        this._scrollRetryTimer = setTimeout(() => {
          this._scrollRetryTimer = null;
          this.scrollExpandedRowIntoView(retriesLeft - 1);
        }, PropertyGroup.SCROLL_INTO_VIEW_RETRY_DELAY_MS);
      }
    }
    // Already fully visible: do nothing — preserves the user's current scroll position.
  }

  /**
   * Debounces scrollExpandedRowIntoView so it runs once, after the expanding row's content
   * has actually finished changing size, instead of once per intermediate size (mount at its
   * "Loading…" placeholder height, then again once real data replaces it, then again if the
   * tab's own inner AG Grid needs a beat to auto-size). Reacting to every one of those steps
   * individually was producing a visible multi-step "creeping" scroll — each step scrolled
   * just enough for ITS height, then the next growth stole back part of that headroom, so the
   * panel could still read as cut off by the time a person actually looks at the screen. Coalescing
   * to the settled state (STABLE_DELAY_MS of quiet) means the one adjustment that's made is
   * already correct for the final layout.
   */
  scheduleScrollIntoView() {
    if (this._scrollIntoViewTimer) clearTimeout(this._scrollIntoViewTimer);
    this._scrollIntoViewTimer = setTimeout(() => {
      this._scrollIntoViewTimer = null;
      this.scrollExpandedRowIntoView();
    }, PropertyGroup.SCROLL_INTO_VIEW_STABLE_DELAY_MS);
  }

  positionDetailContent(entries) {
    // Shared callback for both the childList MutationObserver (fires when the detail
    // panel mounts/unmounts) and the ResizeObserver (fires as its content grows —
    // async data loading in, tab switches, section toggles). Only bail for mutation
    // records that aren't relevant; ResizeObserverEntry objects have no `.type` and
    // should always proceed.
    const isIrrelevantMutation = entries && entries.every(entry => entry.type && entry.type !== 'childList');
    if (isIrrelevantMutation) return;


    // Debounce updates so we schedule at most one per animation frame
    if (this._detailPositionScheduled) return;
    this._detailPositionScheduled = true;


    // Use requestAnimationFrame to ensure AG Grid has updated row positions
    requestAnimationFrame(() => {
      this._detailPositionScheduled = false;
      this.updateDetailPosition();
      this.scheduleScrollIntoView();
    });
  };

  handleDetailPosition() {
    if (!this.gridWrapperEl) return;
    var targetNodes = [...this.gridWrapperEl.getElementsByClassName('ag-full-width-container')];
    if (!targetNodes.length) return;
    var config = { childList: true };
    var observer = new MutationObserver(this.positionDetailContent);
    targetNodes.forEach((node) => observer.observe(node, config));
  }

  shouldRenderClickToDial() {
    const { profile } = this.props;
    if (!profile) return false;

    const userType = profile?.get?.("type");

    return ["FULL", "TEAM_FULL", "TEAM"].includes(userType);
  }

  render() {
    const { children, context = Map(), monitoredLists, loading, exportInProgress, selection, groupFilters, id, name, type, groups, lmEnabled, monitored, layouts, folders, fullAccess, smsRegistered } = this.props;
    const { dragGroup, dragData, selectedTotal, selectedFilter, columnApi, layoutId, topRecords, loadId, isDropActive, showConfirmModal, confirmModalConfig } = this.state;

    if (id !== loadId) {
      if (this.api) {
        this.setState({ loadId: id }, () => {
          this.api.refreshServerSide({ purge: true });
        });
      }
    }

    const selected = selection.get('selected');
    const customGroup = id >= 10;
    const groupType = groupTypeName(context);
    const all = selectedTotal === '';
    const add = selectedTotal === '1';
    const remove = selectedTotal === '0';
    const mobile = type === PropertyGroupTypes.MOBILE;
    const folderEnabled = customGroup && !mobile;
    const { size, addAction, removeAction, addPropertyQuantity, removePropertyQuantity, folderKey } = context.get('info').toJS();

    const totals = [{ type: '', name: 'All Properties', quantity: size }];
    const laAvailable = isLaAvailable();
    const { showAdd, showRemovals } = getAutomateListVisibility(addAction, removeAction);

    if (lmEnabled && monitored) {
      if (showAdd) totals.push({ type: '1', name: 'Additions', quantity: addPropertyQuantity, up: true });
      if (showRemovals) totals.push({ type: '0', name: 'Removals', quantity: removePropertyQuantity, down: true });
    }

    const tileProps = {
      onEdit: this.handleEditGroupFilter,
      // onDragStart: dragStartWrapper(() => this.handleDragStart({ listingType: type, quantity })),
    };

    const baseToggleProps = {
      location: propertyGroupPath(0),
      sizeProperty: 'size',
      selectedId: id,
      draggable: true,
      onBeforeNavigate: this.collapseExpandedDetail,
      onGroupDrop: this.handleGroupDrop,
      onDragStart: this.handleDragStart,
      onDragEnd: this.handleDragEnd,
      dragGroup,
      dragData,
      isDropActive
    };

    const toggleProps = {
      ...baseToggleProps,
      folderDraggable: true,
      allowDrop: true,
      allowAddDrop: true,
      onDeleteFolderClick: this.handleDeleteFolder,
      onEditFolderClick: this.handleEditFolder,
    };

    const monitorTransferLists = groups.filter(g => g.get('type') !== PropertyGroupTypes.MOBILE && g.get('id') !== id);
    const mobileLists = groups.filter(g => g.get('type') === PropertyGroupTypes.MOBILE);
    const toggleList = (type, data, props = toggleProps) => (
      <ToggleList
        {...props}
        type={type}
        folders={folders.filter(f => f.get('type') === type)}
        data={data || groups.filter(g => g.get('type') === type)}
        addItems={!data && [
          { type, label: `Add ${GroupTypeNames[type]}`, onClick: () => this.handleAddGroup(type) },
          { type, label: 'Add Folder', onClick: () => this.handleAddFolder(type) },
        ]}
      />
    );

    const profile = this.props.profile;

    const isAdmin = !profile.get("subUser");
    const hasPermission = profile.get("allowPushToBatchDialer");

    const userType = profile?.get?.("type");

    const showPushToBatchDialer =
      userType === "FULL" ||
      (userType === "TEAM_FULL" && hasPermission);

    return (
      <>
        <div className={`${css.groups} ${css.groupsContainer}`}>
          <div className={css.left}>
            <LeftPart caption="My Properties" onDeleteDrop={this.handleDeleteDrop} allowDrop>
              {toggleList(PropertyGroupTypes.FAVORITE)}
              {toggleList(PropertyGroupTypes.MARKETING)}
              {!monitoredLists.size ? null : toggleList(PropertyGroupTypes.MONITORED, monitoredLists, { ...toggleProps, allowDrop: false, allowAddDrop: false, onAddClick: () => this.handleAddFolder(PropertyGroupTypes.MONITORED), addTitle: 'Add Folder' })}
              {!mobileLists.size ? null : toggleList(PropertyGroupTypes.MOBILE, mobileLists, { ...baseToggleProps, caption: 'Mobile' })}
            </LeftPart>
          </div>
          <div className={css.rightSide}>
            <header className={css.listingTypes}>
              <div className={css.typeContainer}>
                {totals.map(t => <Tile {...tileProps} {...t} selected={selectedTotal === t.type && !selectedFilter} onClick={this.handleTotalClick} key={t.type} loading={loading} />)}
              </div>
              <div className={css.divider} />
              <div className={css.typeContainer} style={{ marginLeft: 0 }}>
                <CarouselTile
                  totals={groupFilters[selectedTotal].filters.filter(t => (laAvailable || !t.disabled) && !NON_LEAD_LIST_TYPES.includes(t.type))}
                  tileProps={tileProps}
                  selectedFilter={selectedFilter}
                  handleFilterClick={this.handleFilterClick}
                  loading={loading}
                />
                <div className={css.padding} />
              </div>
              {lmEnabled ? null : <ListAutomatorPopover className={css.lmOverlay} />}
            </header>
            <section className={css.dashboard}>
              <div className={css.properties}>
                <MyPropertiesControls
                  add={add}
                  remove={remove}
                  mobile={mobile}
                  all={all}
                  loading={loading}
                  exportInProgress={exportInProgress}
                  selected={selected}
                  type={type}
                  monitoredLists={monitoredLists}
                  folderEnabled={folderEnabled}
                  folderKey={folderKey}
                  customGroup={customGroup}
                  context={context}
                  topRecords={topRecords}
                  lmEnabled={lmEnabled}
                  monitored={monitored}
                  fullAccess={fullAccess}
                  name={name}
                  size={size}
                  id={id}
                  monitorTransferLists={monitorTransferLists}
                  columnApi={columnApi}
                  layoutId={layoutId}
                  layouts={layouts}
                  getFixedColumns={() => this.getFixedColumns()}
                  columns={this.columns}
                  gridApi={this.api}
                  handleAddToGroup={(groupType) => this.handleAddToGroup(groupType)}
                  handleRemove={this.handleRemove}
                  handleImport={this.handleImport}
                  handleExport={this.handleExport}
                  openBatchDialerModal={this.openBatchDialerModal}
                  handleOpenContractManager={this.handleOpenContractManager}
                  handleOpenMap={this.handleOpenMap}
                  handleGenerateMailingLabels={this.handleGenerateMailingLabels}
                  handleRename={this.handleRename}
                  handleDeleteGroup={this.handleDeleteGroup}
                  handleEditFilter={this.handleEditFilter}
                  handleAddToFolder={this.handleAddToFolder}
                  handleDeleteFolder={this.handleDeleteFolder}
                  handleEditFolder={this.handleEditFolder}
                  handleNewCampaign={this.handleNewCampaign}
                  handleSkipClick={() => this.handleSkipClick()}
                  handleViewFilter={this.handleViewFilter}
                  handleGridLayoutApply={this.handleGridLayoutApply}
                />
                <div className={css.body}>
                  <div
                    className="ag-theme-balham property-grid"
                    style={{ width: '100%' }}
                    ref={(el) => { this.gridWrapperEl = el; }}
                  >
                    <AgGridReact {...this.gridProps} localeText= {localText } />
                  </div>
                </div>
              </div>
            </section>
          </div>

          {showConfirmModal && (
            <SimpleModal
              isOpen={showConfirmModal}
              title={confirmModalConfig.title}
              modalFooterWrapperClassName={css.customFooterWrapper}
              modalClassName={classNames(css.deleteListConfirmModal, confirmModalConfig.class)}
              customFooter={
                <div className={css.customFooter}>
                  <div className={css.modalDescription} dangerouslySetInnerHTML={{ __html: confirmModalConfig.description }} />
                  {confirmModalConfig.warning && (
                    <div className={css.modalWarning}>{confirmModalConfig.warning}</div>
                  )}
                  <div className={css.buttonGroup}>
                    <button className={confirmModalConfig.submitText ? css.btnSecondary : css.cancelSecondary} onClick={this.handleConfirmModalCancel}>
                      {confirmModalConfig.cancelText || 'Cancel'}
                    </button>
                    <button className={confirmModalConfig.submitText ? css.btnPrimary : css.dangerBtn} onClick={this.handleConfirmModalConfirm}>
                      {confirmModalConfig.submitText || 'Remove'}
                    </button>
                  </div>
                </div>
              }
            />
          )}

          {this.state.removePropertyModal && (
            <RemovePropertyConfirmModal
              onConfirm={this.handleRemovePropertyConfirm}
              onCancel={this.handleRemovePropertyCancel}
            />
          )}

          {this.state.showRenameModal && (
            <RenameListModal
              isOpen={this.state.showRenameModal}
              onClose={this.handleCloseRenameModal}
              onSave={this.handleSaveRename}  // Changed from handleRenameSave to handleSaveRename
              title={this.state.renameConfig.title}
              description={this.state.renameConfig.description}
              initialValue={this.state.renameConfig.initialValue}
              placeholder={this.state.renameConfig.placeholder}
              checkOptions={this.state.renameConfig.checkOptions}
            />
          )}

          {isPropStream() &&
            (((isAdmin && !this.props.isConnected)) ? (
              <BatchDialerModal
                isOpen={this.state.isBatchDialerModalOpen}
                onClose={this.closeBatchDialerModal}
              />
            ) : (!showPushToBatchDialer || !this.props.isConnected) ? (
              <BatchDialerAlert
                isOpen={this.state.isBatchDialerModalOpen}
                onClose={this.closeBatchDialerModal}
              />
            ) : (
              <PushtoBatchDialer
                isOpen={this.state.isBatchDialerModalOpen}
                onClose={this.closeBatchDialerModal}
                agGridRequest={this.state.gridSearch}
              />
            )
            )
          }
          <CampaignActivitySettingsModal
            isOpen={this.state.showActivitySettingsModal}
            onClose={() =>
              this.setState({
                showActivitySettingsModal: false,
                pendingActivityType: null,
                pendingContactIds: [],
              })
            }
            activityType={this.state.pendingActivityType}
            context={CAMPAIGN_ACTIVITY_SETTINGS_CONTEXT.MY_PROPERTY}
            selectionContactIds={this.state.pendingContactIds}
            onSave={this.handleModalSave}
          />
          <LeadAutomatorUpgrade />

          {children}
          {isPropStream() && this.shouldRenderClickToDial() && <ClickToDial profile={this.props.profile} />}
        </div>
      </>
    );
  }
}
/*
                <div className={css.right}>
                  <div className={css.caption}>
                    <div className={css.title}>{name}{` (${size})`}</div>
                  </div>
                </div>
 */

export default withRouter(connect((state) => {
  const context = selectGroupContext(MAIN_CONTEXT)(state);
  const id = context.get('id');
  const info = context.get('info');
  const lmEnabled = selectListManagementEnabled(state);
  const searches = selectSearches(state).toJS();
  const type = info.get('type');
  const batchDialerList = selectBatchDialerList(state);
  const isConnected = Array.isArray(batchDialerList)
    ? batchDialerList.some(item => item.externalSystem === 'BATCH_DIALER')
    : false;
  const profile = selectProfile(state);
  const userId = selectUserId(state);


  // Get filters that are either assigned to this group or defaulted for all groups
  const filters = searches.filter(s => s.savedPropertyGroupId === id || s.defaultFilter).reduce((m, s) => ({ ...m, [`${s.filterType}${s.defaultFilter ? 'D' : ''}`]: s }), {});

  // Get cached counts for this group
  const groupCounts = selectGroupCounts(state).get(String(id), Map()).toJS();

  // Init all/add/remove sets and init filter types for each, pulling cached counts if available and setting applicable filter override info
  const groupFilters = ['', '1', '0'].reduce((m, s) => {
    const counts = groupCounts[s] || { dirty: true };

    return ({
      ...m,
      [s]: {
        dirty: counts.dirty,
        filters: GroupListingTypes.map(t => ({
          ...t,
          disabled: !lmEnabled && t.editable,
          customFilter: filters[t.type] || filters[`${t.type}D`] || null,
          quantity: typeof counts[t.type] === 'number' ? counts[t.type] : null,
        })).map(t => ({ ...t, name: (t.customFilter || t.filter).name, description: (t.customFilter || {}).description })),
      },
    });
  }, {});

  return {
    id,
    context,
    groupFilters,
    lmEnabled,
    name: info.get('name'),
    type,
    monitored: type === PropertyGroupTypes.MONITORED,
    smsRegistered: selectSmsEnabled(state) && selectSmsRegistered(state),
    loading: selectLoading(state) || selectCampaignLoading(state) || selectContactLoading(state),
    // Kept out of the page-wide `loading` on purpose: only the Export action shows it, so the rest of
    // My Properties stays usable while a background export is polled and confirmed.
    exportInProgress: selectExportInProgress(state),
    groups: selectGroups(state),
    folders: selectFolders(state),
    favorites: selectFavorites(state),
    lists: selectLists(state),
    monitoredLists: selectMonitoredLists(state),
    alerts: selectAlerts(state),
    selection: selectSelection(state),
    layout: selectPropertyGridLayout(state),
    filters: selectFilters(state),
    layouts: selectLayouts(state).filter(l => l.get('type') === 'PROPERTY_GRID').toJS(),
    fullAccess: selectFullAccessPermission(state),
    batchDialerList,
    isConnected,
    userId,
    appendGroups: selectAppendGroups(state),
    usageSectionDetails: selectUsageSection(state),
    profile: selectProfile(state),
    planDetails: selectPlanDetails(state)?.toJS(),
    isLegacyAccount: isLegacyAccountPlan(state),
  };
}, {
  setPropertySelection,
  authenticate,
  clearPropertySelection,
  loadGroupContext,
  updateGroupContext,
  exportGroupProperties,
  deletePropertyGroup,
  deleteGroupProperties,
  saveGroupProperties,
  searchGroupProperties,
  getSavedPropertyDetail,
  searchPropertyContacts,
  getGroupSearch,
  saveGroupSearch,
  savePropertyGroupFilter,
  deletePropertyGroupFilter,
  getGroupPropertyCounts,
  createDialerCampaign,
  createDirectMailCampaign,
  getMarketingProfile,
  createSmsCampaign,
  loadCampaign,
  loadCampaigns,
  getBatchDialerIntegration,
  setBatchDialerSource,
  openAppendJobEditor: AppendJobEditor.open,
  openPostcardPreview: PostcardPreviewPopup.open,
  confirm: Confirm.open,
  confirmRemoval: Confirm.confirmRemoval,
  alert: Confirm.alert,
  prompt: Prompt.open,
  openContractManager: ContractManagerPopup.open,
  openAddToGroup: AddToGroup.open,
  openAddToMarketingListModal: AddToMarketingListModal.open,
  openAddToFolder: AddToFolder.open,
  openMap: PropertyGroupMap.open,
  openImport: PropertyImport.open,
  openSearchFilterViewer: SearchFilterViewerPopupNew.open,
  openCustomFilterModal: CustomFilterModal.open,
  openExportPropertyConfirmation: ExportPropertyConfirmation.open,
  openLaunchControlConfirmation: LaunchControlConfirmation.open,
  openMailingLabels: MailingLabelsPopup.open,
  savePropertyFolder,
  deletePropertyFolder,
  openLeadAutomatorUpgrade,
  showAlert: InfoAlert.open,
  skipTraceModal: SkipTraceModal.open,
  getAppendJobEstimate,
  leaveMessagePopup: LeaveMessagePopup.open,
  purchaseSavesAndExportsPopup: PurchaseSavesAndExportsPopup.open,
  openAccountUpgrade: ActivateSubscriptionPopup.open,
  openFullAccessRequiredModal: FullAccessRequiredModal.open,
  closeFullAccessRequiredModal: FullAccessRequiredModal.close
})(deferExecutor(PropertyGroup)));